"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HouseholdPanel = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const AuditDisplay_1 = __importDefault(require("../AuditDisplay"));
const SurveyObjectBox_1 = require("./SurveyObjectBox");
const HouseholdPanel = ({ household, audits, showAuditErrorCode, inheritedStatus }) => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin']);
    if (!household) {
        return (react_1.default.createElement("div", { className: "admin__interview-stats", key: "household" },
            react_1.default.createElement("details", { open: true, className: "admin__survey-object-box" },
                react_1.default.createElement("summary", null,
                    react_1.default.createElement("h4", { style: { display: 'inline', margin: 0 } }, t('Household'))),
                react_1.default.createElement("span", { className: "_widget _red" }, t('interviewStats.errors.householdNotAvailable')),
                audits && audits.length > 0 && (react_1.default.createElement(AuditDisplay_1.default, { audits: audits, showAuditErrorCode: showAuditErrorCode })))));
    }
    return (react_1.default.createElement("div", { className: "admin__interview-stats", key: "household" },
        react_1.default.createElement(SurveyObjectBox_1.SurveyObjectBox, { as: "details", defaultOpen: true, objectType: "household", objectUuid: household._uuid, inheritedStatus: inheritedStatus, summary: react_1.default.createElement("summary", null,
                react_1.default.createElement("h4", { style: { display: 'inline', margin: 0 } }, t('Household'))) },
            react_1.default.createElement("span", { className: "_widget" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleUser, className: "faIconLeft" }),
                household.size),
            react_1.default.createElement("span", { className: "_widget" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCar, className: "faIconLeft" }),
                household.carNumber),
            react_1.default.createElement("span", { className: "_widget" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDollarSign, className: "faIconLeft" }),
                household.incomeLevel),
            audits && audits.length > 0 && (react_1.default.createElement(AuditDisplay_1.default, { audits: audits, showAuditErrorCode: showAuditErrorCode })))));
};
exports.HouseholdPanel = HouseholdPanel;
//# sourceMappingURL=HouseholdPanel.js.map